import { render, staticRenderFns } from "./submission_selector.vue?vue&type=template&id=050dc960&scoped=true&"
import script from "./submission_selector.vue?vue&type=script&lang=ts&"
export * from "./submission_selector.vue?vue&type=script&lang=ts&"
import style0 from "./submission_selector.vue?vue&type=style&index=0&id=050dc960&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050dc960",
  null
  
)

export default component.exports